import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { ETourTargetType } from '../../../../enums/tours.enum';
import { Tour } from '../../../../interfaces/tours';

const { confirm } = Modal;

interface ConfirmModalProps {
    targetType: ETourTargetType;
    targetIds: string[];
    countries: any[];
    applyToNewWorkspacesOnly: boolean;
    tourSelected: Tour | null;
    onConfirm: () => void;
}

const showTourConfirmModal = ({
    targetType,
    targetIds,
    countries,
    applyToNewWorkspacesOnly,
    tourSelected,
    onConfirm,
}: ConfirmModalProps) => {
    let message = '';

    if (targetType === ETourTargetType.COUNTRY) {
        const selectedCountries = countries
            .filter((country: any) => targetIds.includes(country.id))
            .map((country: any) => country.name);

        if (selectedCountries.length === 0) {
            message = '¿Estás seguro de que deseas crear/actualizar este tour sin países seleccionados?';
        } else if (selectedCountries.length === 1) {
            message = `Se enviará el tour a todos los clientes de ${selectedCountries[0]}, ¿Estás seguro de que deseas continuar?`;
        } else {
            const countryList = selectedCountries.join(', ');
            message = `Se enviará el tour a todos los clientes de: ${countryList}, ¿Estás seguro de que deseas continuar?`;
        }
    } else {
        const workspacesCount = applyToNewWorkspacesOnly
            ? 'todos los workspaces nuevos'
            : `${targetIds.length} workspace${targetIds.length !== 1 ? 's' : ''}`;

        if (applyToNewWorkspacesOnly) {
            message = 'Se enviará el tour a todos los workspaces nuevos, ¿Estás seguro de que deseas continuar?';
        } else {
            message = `Se enviará el tour a ${workspacesCount}, ¿Estás seguro de que deseas continuar?`;
        }
    }

    confirm({
        title: tourSelected ? 'Confirmar actualización de tour' : 'Confirmar creación de tour',
        icon: <ExclamationCircleOutlined />,
        content: message,
        okText: tourSelected ? 'Sí, actualizar' : 'Sí, crear',
        cancelText: 'Cancelar',
        onOk: onConfirm,
    });
};

export default showTourConfirmModal;
